import * as React from 'react'

export const VideoThumbnailPlayIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={98}
    viewBox="0 0 70 95"
    {...props}
  >
    <image
      width="42.15"
      height="49.88"
      x="13.92"
      y="24.06"
      preserveAspectRatio="none"
      href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAACOCAYAAAD6r8zWAAAABHNCSVQICAgIfAhkiAAABDhJREFUeJztnV1y4yAQBtFezPhkxieTfLLdl8WJEyzzM8AA3W+pihVZXfOFGcvImEzsf3JfD4qw1lrnnPt7wr7vu3PO9T5XSMBaa/d938/EvpPd+9zhAzlif0JFKyS3at+x7/vO/2olWGutlNiQ6N7vb3kkK/cdxHYnWsj1ENuNqRnNZ1DNjWhZvSGo5sr0lOshtivxaUL1k1Csph4j9fhQQIqcswqT7p+pZiFiL3hsZUku2IhtAWIvdupxJauZ2C6glmBjiG0V1BTskVyEMfJMpIVgD7HdgZaCjZGNbRZhEbQW7CG2G9FLsDHyizBiO0BPwR5654poEOwhtiugSbAxxLY42gR7iG0htAr2UM2FaBdsDCPPIkYQ7JFehC0heiTBHmI7gREFG0NsRzOqYA+x/YHRBRtD73zKDII99M4BZhLsYeT5jRkFG0NsP5lVsGf52J5dsEf6O8+93080qwg2ZtHYXkmwZ6neeUXBniVie2XBxiww8lxdsGfa2EbwF1MuwhD8G+ktLbpWM4LfM0VsI/ic4WMbwXEMG9sITmO4bR4RnM5QsY3gfIZYhCG4HNUjTwTLoDa2ESyLuthGsDw1NlXPPhkE10O6d86KbQTXp2tsI7gN3RZhCG5L85EngvvQbBGG4H5IbwoX/CMI7o/UIiwoGcF6kKjmX5IRrAuJ2H5ZYSNYJ6Wx/TwQgvVSUs3PKkawfnJ7Z2MMgkci5xFIf3qfNMTjnHPX6/Wa9CIqeDxSKnmLlbdt21b7xCGeWG9E9OQgeHIQPCApd3YgeEAul8sl5veO4zgQPBgpt+w8Ho8HbdIg5EyzrLUWwcrJnUc/PzZEsF5KPlF6xjiC9VF6Y97Lh/4I1oPUPVovizAE60DqvqxfK2wE90Xyzspg+4TgfjTZYQ/B7Wm6Iz2C2yF9o3vURAvBbej27X8E10X6kQLJJ4DgOqjZphjB8kguooo3Y0GwHCqf8ILgctTEcQgEl6EqjkMgOI8uPW0OCE5H5Y5270BwPEM+9BLBnxkmjkMg+Jyh4jgEgsN0HzFKgeBXVPe0OSD4C/U9bQ4IVjpilGJlwdPFcYhVBU8ZxyFWEzx0T5vDSoKH72lzWEHwkCNGKWYWvFwch5hV8JJxHGI2wdOMGKWYRfASPW0OMwhepqfNYWTBU48YpRhRMHGcwGiCieNERhFMT5vJCILpaQvQLHjpEaMUGgUTx4JoE0wcC6NFMCPGSvQWTE9bmZ6C6Wkb0EMwI8aGtBRMHHeglWDiuBO1BdPTdqamYHpaBcRe4JTKYcSoiNgqi7nQxLFCUqrtTDJxrJPNV13Ki+73+/37z7fb7SZxMsdxHMmPT4XPSFVeCcRxRSQXRakQx41oLZZFVGMk58OfQGwnakc1cawAyXbHQxwrQzKuqVqllE6lGDEOQqpo55wjjvWwpfzyWdwe/yk9IQBI4B91Yz7DzPq/QgAAAABJRU5ErkJggg=="
    />
  </svg>
)

export default VideoThumbnailPlayIcon
